import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { formatVolume } from '../../lib/utils/units.ts';

var root_1 = $.from_svg(`<g><rect rx="4"></rect><text text-anchor="middle" class="bar-label svelte-xvyzdsyeeuel"> </text></g>`);
var root_2 = $.from_svg(`<text text-anchor="middle" class="selected-label svelte-xvyzdsyeeuel"> </text>`);
var root = $.from_svg(`<svg class="daily-chart svelte-xvyzdsyeeuel"><!><!></svg>`);

function DailyChart($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	const width = 320;
	const height = 160;
	const padding = { top: 10, right: 10, bottom: 24, left: 10 };
	const chartW = $.derived(() => width - padding.left - padding.right);
	const chartH = $.derived(() => height - padding.top - padding.bottom);
	const maxVal = $.derived(() => Math.max(...$$props.data.map((d) => d.totalPumpMl), 1));

	const barWidth = $.derived(() => $$props.data.length > 0
		? Math.min($.get(chartW) / $$props.data.length - 4, 28)
		: 20);

	function barX(i) {
		if ($$props.data.length === 0) return 0;

		const gap = $.get(chartW) / $$props.data.length;

		return padding.left + gap * i + (gap - $.get(barWidth)) / 2;
	}

	function barH(val) {
		return val / $.get(maxVal) * $.get(chartH);
	}

	let selectedIndex = $.state(null);
	var svg = root();

	$.set_attribute(svg, 'viewBox', '0 0 320 160');

	var node = $.child(svg);

	$.each(node, 17, () => $$props.data, $.index, ($$anchor, day, i) => {
		var g = root_1();
		var rect = $.child(g);
		var text = $.sibling(rect);

		$.set_attribute(text, 'y', height - 4);

		var text_1 = $.child(text, true);

		$.reset(text);
		$.reset(g);

		$.template_effect(
			($0, $1, $2, $3, $4) => {
				$.set_attribute(rect, 'x', $0);
				$.set_attribute(rect, 'y', $1);
				$.set_attribute(rect, 'width', $.get(barWidth));
				$.set_attribute(rect, 'height', $2);
				$.set_attribute(rect, 'fill', $.get(selectedIndex) === i ? 'var(--secondary)' : 'var(--primary)');
				$.set_attribute(rect, 'opacity', $.get(day).totalPumpMl > 0 ? $.get(selectedIndex) === i ? 1 : 0.7 : 0.15);
				$.set_attribute(text, 'x', $3);
				$.set_text(text_1, $4);
			},
			[
				() => barX(i),
				() => padding.top + $.get(chartH) - barH($.get(day).totalPumpMl),
				() => barH($.get(day).totalPumpMl),
				() => barX(i) + $.get(barWidth) / 2,
				() => new Date($.get(day).date).toLocaleDateString([], { weekday: 'narrow' })
			]
		);

		$.delegated('click', g, () => $.set(selectedIndex, i, true));
		$.append($$anchor, g);
	});

	var node_1 = $.sibling(node);

	{
		var consequent = ($$anchor) => {
			var text_2 = root_2();

			$.set_attribute(text_2, 'x', width / 2);

			var text_3 = $.child(text_2, true);

			$.reset(text_2);

			$.template_effect(
				($0) => {
					$.set_attribute(text_2, 'y', padding.top + 12);
					$.set_text(text_3, $0);
				},
				[
					() => formatVolume($$props.data[$.get(selectedIndex)].totalPumpMl, $.get(isImperial))
				]
			);

			$.append($$anchor, text_2);
		};

		$.if(node_1, ($$render) => {
			if ($.get(selectedIndex) !== null && $$props.data[$.get(selectedIndex)]) $$render(consequent);
		});
	}

	$.reset(svg);
	$.append($$anchor, svg);
	$.pop();
}

if (import.meta.hot) {
	DailyChart = $.hmr(DailyChart);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-xvyzdsyeeuel');
		DailyChart[$.HMR].update(module.default);
	});
}

export default DailyChart;

$.delegate(['click']);
import "bun-svelte:DailyChart.svelte-2hzm624ewwfz4-style.css";